export class CssHelper {
    constructor(private classes: string[]) {
    }

    add(className: string, condition?: boolean) {
        if (condition !== false) {
            this.classes.push(className);
        }

        return this;
    }

    toString() {
        return this.classes.join(" ");
    }
}

export function cssHelper(...classes: string[]) {
    return new CssHelper(classes);
}